import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Card,
  Tabs,
  Tab,
  Table,
  Modal,
} from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { getAllEventTypes } from "../Api/Event";
import Select from "react-select";
import { FaEdit, FaTrash, FaPlus, FaFileUpload, FaDownload, FaFile } from "react-icons/fa";

import {
  fetchEventByCode,
  fetchParticipantsByEvent,
  fetchRemindersByEvent,
  fetchMoMByEvent,
} from "../Api/ViewEvent";

import {
  updateEvent,
  addParticipants,
  addReminder,
  addMoM,
  updateParticipant,
  deleteParticipant,
  updateReminder,
  deleteReminder,
  updateMoMHeader,
  updateMoMDetail,
  deleteMoMDetail,
  addMoMDetail,
  uploadEventDocument,
  getEventDocuments,
  downloadEventDocument,
  deleteEventDocument,
  downloadFile,
} from "../Api/Event";

import { getDepartmentsByOrgId } from "../Api/DepartmentOrgMaster";
import { getAllCompanyCodes } from "../Api/CompanyLocationMaster";
import { fetchCostCenters } from "../Api/ResourceMaster";
import { getResourcesByOrgId } from "../Api/ResourceList";
import { fetchCustomersByOrgId } from "../Api/InvoiceApi";
import { fetchProjectsByOrg } from "../Api/ViewProjects";
import { getTicketsByOrgId } from "../Api/TicketApiOrg";

import "./EditEvent.css";

const EditEvent = () => {
  const { eventCode } = useParams();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const orgId = userDetails?.organisationId;
  const userId = userDetails?.userId;

  const [eventData, setEventData] = useState(null);
  const [eventTypes, setEventTypes] = useState([]);

  // Dropdown data
  const [companyOptions, setCompanyOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [costCenterOptions, setCostCenterOptions] = useState([]);
  const [resourceOptions, setResourceOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [eventTypeOptions, setEventTypeOptions] = useState([]);

  // Projects and Tickets for Entity
  const [projects, setProjects] = useState([]);
  const [tickets, setTickets] = useState([]);

  const [participants, setParticipants] = useState([]);
  const [existingParticipants, setExistingParticipants] = useState([]);

  // Edit Participant State
  const [showEditParticipantModal, setShowEditParticipantModal] = useState(false);
  const [editingParticipant, setEditingParticipant] = useState(null);

  const [reminderMinutes, setReminderMinutes] = useState("");
  const [reminderType, setReminderType] = useState("");
  const [isSent, setIsSent] = useState(false);
  const [existingReminders, setExistingReminders] = useState([]);

  // Edit Reminder State
  const [showEditReminderModal, setShowEditReminderModal] = useState(false);
  const [editingReminder, setEditingReminder] = useState(null);

  const [existingMoM, setExistingMoM] = useState(null);

  // MoM STRUCTURE
  const [momMeta, setMomMeta] = useState({
    preparedBy: "",
    approvedBy: "",
  });

  const [momDetails, setMomDetails] = useState([]);

  // Edit MoM Detail State
  const [showEditMoMDetailModal, setShowEditMoMDetailModal] = useState(false);
  const [editingMoMDetail, setEditingMoMDetail] = useState(null);

  // Add MoM Detail State
  const [showAddMoMDetailModal, setShowAddMoMDetailModal] = useState(false);
  const [newMoMDetail, setNewMoMDetail] = useState({
    discussionPoint: "",
    decisionTaken: "",
    actionItem: "",
  });

  // Document states
  const [documents, setDocuments] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [documentTypeId, setDocumentTypeId] = useState(1);
  const [uploadingDoc, setUploadingDoc] = useState(false);

  // Document type options
  const documentTypeOptions = [
    { value: 1, label: "📄 Contract" },
    { value: 2, label: "💰 Invoice" },
    { value: 3, label: "📊 Report" },
    { value: 4, label: "📽️ Presentation" },
    { value: 5, label: "📎 Other" },
  ];

  // ================= LOAD DROPDOWNS =================

  const loadCompanyCodes = async () => {
    try {
      const data = await getAllCompanyCodes(orgId);
      const options = data.map((company) => ({
        value: company.companyCode,
        label: `${company.name} (${company.companyCode})`,
      }));
      const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
      setCompanyOptions(sortedOptions);
    } catch (error) {
      console.error("Error fetching company codes:", error);
    }
  };

  const loadDepartments = async () => {
    try {
      const data = await getDepartmentsByOrgId(orgId);
      const options = data.map((dept) => ({
        value: dept.guid,
        label: `${dept.deptDescription} (${dept.deptCode})`,
      }));
      const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
      setDepartmentOptions(sortedOptions);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const loadCostCenters = async () => {
    try {
      const data = await fetchCostCenters();
      const options = data.map((center) => ({
        value: center.code,
        label: `${center.description} (${center.code})`,
      }));
      const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
      setCostCenterOptions(sortedOptions);
    } catch (error) {
      console.error("Error fetching cost centers:", error);
    }
  };

  const loadResources = async () => {
    try {
      const data = await getResourcesByOrgId(orgId);
      const options = data.map((resource) => ({
        value: resource.resourceId,
        label: `${resource.name} (${resource.resourceId})`,
      }));
      const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
      setResourceOptions(sortedOptions);
    } catch (error) {
      console.error("Error fetching resources:", error);
    }
  };

  const loadCustomers = async () => {
    try {
      const data = await fetchCustomersByOrgId(orgId);
      const options = data.map((customer) => ({
        value: customer.customerCode,
        label: `${customer.name} (${customer.customerCode})`,
      }));
      const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
      setCustomerOptions(sortedOptions);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const loadProjects = async () => {
    try {
      const data = await fetchProjectsByOrg(orgId);
      const sortedProjects = data.sort((a, b) => a.prTitle.localeCompare(b.prTitle));
      setProjects(sortedProjects);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const loadTickets = async () => {
    try {
      const data = await getTicketsByOrgId(orgId);
      const sortedTickets = data.sort((a, b) => a.ticketName.localeCompare(b.ticketName));
      setTickets(sortedTickets);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };

  const projectOptions = projects.map((p) => ({
    value: p.projectId,
    label: `${p.prTitle} (${p.projectId})`,
  }));

  const ticketOptions = tickets.map((t) => ({
    value: t.ticketId,
    label: `${t.ticketName} (${t.ticketId})`,
  }));

  // ================= LOAD MAIN DATA =================

  useEffect(() => {
    loadAll();
  }, []);

  useEffect(() => {
    if (eventData?.entityType === "Project") {
      loadProjects();
    } else if (eventData?.entityType === "Ticket") {
      loadTickets();
    }
  }, [eventData?.entityType]);

  const loadAll = () => {
    loadEvent();
    loadParticipants();
    loadReminders();
    loadMoM();
    loadEventTypes();
    loadCompanyCodes();
    loadDepartments();
    loadCostCenters();
    loadResources();
    loadCustomers();
    loadDocuments();
  };

  const loadEvent = async () => {
    try {
      const data = await fetchEventByCode(orgId, eventCode);
      setEventData({
        eventName: data.eventName,
        eventType: data.eventType,
        eventDate: moment(data.eventDate).format("YYYY-MM-DD"),
        eventEndDate: data.eventEndDate ? moment(data.eventEndDate).format("YYYY-MM-DD") : "",
        eventStartTime: data.eventStartTime ? data.eventStartTime.slice(0, 5) : "",
        eventEndTime: data.eventEndTime ? data.eventEndTime.slice(0, 5) : "",
        eventLocation: data.eventLocation,
        organizerName: data.organizerName,
        budgetAllocation: data.budgetAllocation,
        department: data.department,
        eventDescription: data.eventDescription,
        entityType: data.entityType || "",
        entityId: data.entityId || "",
        eventCompanyCode: data.eventCompanyCode || "",
        eventCostCenter: data.eventCostCenter || "",
        eventResource: data.eventResource || "",
        eventClient: data.eventClient || "",
      });
    } catch {
      toast.error("Error loading event");
    }
  };

  const loadParticipants = async () => {
    try {
      const data = await fetchParticipantsByEvent(eventCode);
      setExistingParticipants(data);
    } catch {
      toast.error("Error loading participants");
    }
  };

  const loadReminders = async () => {
    try {
      const data = await fetchRemindersByEvent(eventCode);
      setExistingReminders(data);
    } catch {
      toast.error("Error loading reminders");
    }
  };

  const loadMoM = async () => {
    try {
      const data = await fetchMoMByEvent(eventCode);
      setExistingMoM(data);
      setMomMeta({
        preparedBy: data?.preparedBy || "",
        approvedBy: data?.approvedBy || "",
      });
      setMomDetails(data?.details || []);
    } catch {
      toast.error("Error loading MoM");
    }
  };

  const loadEventTypes = async () => {
    try {
      const data = await getAllEventTypes();
      const sortedData = data.sort((a, b) => a.typeName.localeCompare(b.typeName));
      setEventTypes(sortedData);
      const options = sortedData.map((e) => ({
        value: e.eventTypeGuid,
        label: e.typeName,
      }));
      setEventTypeOptions(options);
    } catch {
      toast.error("Error loading event types");
    }
  };

  // ================= DOCUMENT HANDLERS =================

  const loadDocuments = async () => {
    try {
      const response = await getEventDocuments(orgId, eventCode);
      console.log(response);
      setDocuments(response.documents || []);
    } catch (error) {
      console.error("Error loading documents:", error);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10485760) {
        toast.error("File size cannot exceed 10MB");
        return;
      }
      setSelectedFile(file);
    }
  };

  const handleUploadDocument = async () => {
    if (!selectedFile) {
      toast.error("Please select a file");
      return;
    }

    setUploadingDoc(true);
    try {
      await uploadEventDocument({
        file: selectedFile,
        eventDoctypeId: documentTypeId,
        eventParentId: eventCode,
        orgId: parseInt(orgId),
        createdBy: String(userId),
      });
      toast.success("Document uploaded successfully");
      setSelectedFile(null);
      loadDocuments();
      const fileInput = document.getElementById("editDocumentFileInput");
      if (fileInput) fileInput.value = "";
    } catch (error) {
      toast.error(error.message || "Failed to upload document");
    } finally {
      setUploadingDoc(false);
    }
  };

  const handleDownloadDocument = async (docGuid, fileName) => {
    try {
      const response = await downloadEventDocument(docGuid);
      downloadFile(response.data, fileName);
      toast.success("Download started");
    } catch (error) {
      toast.error("Failed to download document");
    }
  };

  const handleDeleteDocument = async (docGuid) => {
    if (window.confirm("Are you sure you want to delete this document?")) {
      try {
        await deleteEventDocument(docGuid, String(userId));
        toast.success("Document deleted successfully");
        loadDocuments();
      } catch (error) {
        toast.error("Failed to delete document");
      }
    }
  };

  const formatDate = (date, time) => {
    if (!date) return "N/A";
    const dateObj = new Date(date);
    if (time) {
      const [hours, minutes, seconds] = time.split(":");
      dateObj.setHours(parseInt(hours), parseInt(minutes), parseInt(seconds || 0));
    }
    return dateObj.toLocaleString();
  };

  // ================= HANDLERS =================

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "entityType") {
      setEventData({ ...eventData, entityType: value, entityId: "" });
    } else {
      setEventData({ ...eventData, [name]: value });
    }
  };

  const handleEntitySelect = (selected) => {
    setEventData({ ...eventData, entityId: selected?.value || "" });
  };

  const handleOverviewSave = async () => {
    try {
      const payload = {
        ...eventData,
        eventDate: new Date(eventData.eventDate).toISOString(),
        eventEndDate: eventData.eventEndDate ? new Date(eventData.eventEndDate).toISOString() : null,
        eventStartTime: eventData.eventStartTime ? `${eventData.eventStartTime}:00` : null,
        eventEndTime: eventData.eventEndTime ? `${eventData.eventEndTime}:00` : null,
        eventCompanyCode: eventData.eventCompanyCode || null,
        eventCostCenter: eventData.eventCostCenter || null,
        eventResource: eventData.eventResource || null,
        eventClient: eventData.eventClient || null,
        entityType: eventData.entityType || null,
        entityId: eventData.entityId || null,
        createdBy: String(userId),
        organisationId: String(orgId),
      };
      await updateEvent(eventCode, payload);
      toast.success("Event Updated Successfully");
    } catch {
      toast.error("Failed to update event");
    }
  };

  // ================= PARTICIPANT CRUD =================

  const handleAddParticipant = async () => {
    try {
      const payload = participants.map((p) => ({
        ...p,
        createdBy: String(userId),
        organisationId: String(orgId),
      }));
      await addParticipants(eventCode, payload);
      toast.success("Participants Added");
      setParticipants([]);
      loadParticipants();
    } catch {
      toast.error("Error adding participants");
    }
  };

  const handleEditParticipant = (participant) => {
    setEditingParticipant(participant);
    setShowEditParticipantModal(true);
  };

  const handleUpdateParticipant = async () => {
    try {
      await updateParticipant(editingParticipant.participantGuid, {
        userId: editingParticipant.userId,
        participantRole: editingParticipant.participantRole,
        status: editingParticipant.status,
        createdBy: String(userId),
      });
      toast.success("Participant updated successfully");
      setShowEditParticipantModal(false);
      loadParticipants();
    } catch {
      toast.error("Error updating participant");
    }
  };

  const handleDeleteParticipant = async (participantGuid) => {
    if (window.confirm("Are you sure you want to delete this participant?")) {
      try {
        await deleteParticipant(participantGuid, String(userId));
        toast.success("Participant deleted successfully");
        loadParticipants();
      } catch {
        toast.error("Error deleting participant");
      }
    }
  };

  // ================= REMINDER CRUD =================

  const handleAddReminder = async () => {
    try {
      const payload = {
        reminderMinutes: Number(reminderMinutes),
        reminderType,
        isSent: isSent === "true",
        createdBy: String(userId),
        organisationId: String(orgId),
      };
      await addReminder(eventCode, payload);
      toast.success("Reminder Saved");
      setReminderMinutes("");
      setReminderType("");
      setIsSent(false);
      loadReminders();
    } catch {
      toast.error("Error saving reminder");
    }
  };

  const handleEditReminder = (reminder) => {
    setEditingReminder(reminder);
    setShowEditReminderModal(true);
  };

  const handleUpdateReminder = async () => {
    try {
      await updateReminder(editingReminder.reminderGuid, {
        reminderMinutes: Number(editingReminder.reminderMinutes),
        reminderType: editingReminder.reminderType,
        isSent: editingReminder.isSent,
        createdBy: String(userId),
      });
      toast.success("Reminder updated successfully");
      setShowEditReminderModal(false);
      loadReminders();
    } catch {
      toast.error("Error updating reminder");
    }
  };

  const handleDeleteReminder = async (reminderGuid) => {
    if (window.confirm("Are you sure you want to delete this reminder?")) {
      try {
        await deleteReminder(reminderGuid, String(userId));
        toast.success("Reminder deleted successfully");
        loadReminders();
      } catch {
        toast.error("Error deleting reminder");
      }
    }
  };

  // ================= MOM CRUD =================

  const handleUpdateMoMHeader = async () => {
    try {
      await updateMoMHeader(eventCode, {
        preparedBy: momMeta.preparedBy,
        approvedBy: momMeta.approvedBy,
        changedBy: String(userId),
      });
      toast.success("MoM Header updated successfully");
      loadMoM();
    } catch {
      toast.error("Error updating MoM header");
    }
  };

  const handleEditMoMDetail = (detail) => {
    setEditingMoMDetail(detail);
    setShowEditMoMDetailModal(true);
  };

  const handleUpdateMoMDetail = async () => {
    try {
      await updateMoMDetail(editingMoMDetail.moMdetailGuid, {
        discussionPoint: editingMoMDetail.discussionPoint,
        decisionTaken: editingMoMDetail.decisionTaken,
        actionItem: editingMoMDetail.actionItem,
      });
      toast.success("MoM detail updated successfully");
      setShowEditMoMDetailModal(false);
      loadMoM();
    } catch {
      toast.error("Error updating MoM detail");
    }
  };

  const handleDeleteMoMDetail = async (detailGuid) => {
    if (window.confirm("Are you sure you want to delete this MoM detail?")) {
      try {
        await deleteMoMDetail(detailGuid, String(userId));
        toast.success("MoM detail deleted successfully");
        loadMoM();
      } catch {
        toast.error("Error deleting MoM detail");
      }
    }
  };

  const handleAddMoMDetail = async () => {
    try {
      await addMoMDetail(eventCode, {
        discussionPoint: newMoMDetail.discussionPoint,
        decisionTaken: newMoMDetail.decisionTaken,
        actionItem: newMoMDetail.actionItem,
        createdBy: String(userId),
        organisationId: String(orgId),
      });
      toast.success("MoM detail added successfully");
      setShowAddMoMDetailModal(false);
      setNewMoMDetail({
        discussionPoint: "",
        decisionTaken: "",
        actionItem: "",
      });
      loadMoM();
    } catch {
      toast.error("Error adding MoM detail");
    }
  };

  if (!eventData) return null;

  return (
    <div className="main-content expand">
      <Container fluid className="ems-edit-container">
        <div className="ems-title-wrapper">
          <div className="d-flex align-items-center flex-wrap">
            <h2 className="ems-page-title">{eventData.eventName}</h2>
            <div className="ems-event-badge">
              <span>📅</span>
              <code>{eventCode}</code>
            </div>
          </div>
        </div>

        <Tabs defaultActiveKey="overview" className="ems-custom-tabs">
          {/* Overview Tab */}
          <Tab eventKey="overview" title="📋 Overview">
            <Card className="ems-glass-card">
              <Card.Body className="ems-card-body">
                <Form>
                  <Row className="ems-row-gap">
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Event Name</Form.Label>
                        <Form.Control
                          className="ems-form-control"
                          name="eventName"
                          value={eventData.eventName}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Event Type</Form.Label>
                        <Select
                          className="ems-react-select"
                          classNamePrefix="ems-react-select"
                          options={eventTypeOptions}
                          value={eventTypeOptions.find((opt) => opt.value === eventData.eventType)}
                          onChange={(selected) =>
                            setEventData({
                              ...eventData,
                              eventType: selected?.value || "",
                            })
                          }
                          placeholder="Select Event Type"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3 ems-row-gap">
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Event Date</Form.Label>
                        <Form.Control
                          type="date"
                          className="ems-form-control"
                          name="eventDate"
                          value={eventData.eventDate}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">End Date</Form.Label>
                        <Form.Control
                          type="date"
                          className="ems-form-control"
                          name="eventEndDate"
                          value={eventData.eventEndDate}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Budget (₹)</Form.Label>
                        <Form.Control
                          type="number"
                          className="ems-form-control"
                          name="budgetAllocation"
                          value={eventData.budgetAllocation}
                          onChange={handleChange}
                          placeholder="Enter budget amount"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3 ems-row-gap">
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Start Time</Form.Label>
                        <Form.Control
                          type="time"
                          className="ems-form-control"
                          name="eventStartTime"
                          value={eventData.eventStartTime}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">End Time</Form.Label>
                        <Form.Control
                          type="time"
                          className="ems-form-control"
                          name="eventEndTime"
                          value={eventData.eventEndTime}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Location</Form.Label>
                        <Form.Control
                          className="ems-form-control"
                          name="eventLocation"
                          value={eventData.eventLocation}
                          onChange={handleChange}
                          placeholder="Enter venue/location"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3 ems-row-gap">
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Organizer</Form.Label>
                        <Form.Control
                          className="ems-form-control"
                          name="organizerName"
                          value={eventData.organizerName}
                          onChange={handleChange}
                          placeholder="Enter organizer name"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Department</Form.Label>
                        <Select
                          className="ems-react-select"
                          classNamePrefix="ems-react-select"
                          options={departmentOptions}
                          value={departmentOptions.find((opt) => opt.value === eventData.department)}
                          onChange={(selected) =>
                            setEventData({
                              ...eventData,
                              department: selected?.value || "",
                            })
                          }
                          placeholder="Select Department"
                          isClearable
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3 ems-row-gap">
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Company Code</Form.Label>
                        <Select
                          className="ems-react-select"
                          classNamePrefix="ems-react-select"
                          options={companyOptions}
                          value={companyOptions.find((opt) => opt.value === eventData.eventCompanyCode)}
                          onChange={(selected) =>
                            setEventData({
                              ...eventData,
                              eventCompanyCode: selected?.value || "",
                            })
                          }
                          placeholder="Select Company"
                          isClearable
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Cost Center</Form.Label>
                        <Select
                          className="ems-react-select"
                          classNamePrefix="ems-react-select"
                          options={costCenterOptions}
                          value={costCenterOptions.find((opt) => opt.value === eventData.eventCostCenter)}
                          onChange={(selected) =>
                            setEventData({
                              ...eventData,
                              eventCostCenter: selected?.value || "",
                            })
                          }
                          placeholder="Select Cost Center"
                          isClearable
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Resource</Form.Label>
                        <Select
                          className="ems-react-select"
                          classNamePrefix="ems-react-select"
                          options={resourceOptions}
                          value={resourceOptions.find((opt) => opt.value === eventData.eventResource)}
                          onChange={(selected) =>
                            setEventData({
                              ...eventData,
                              eventResource: selected?.value || "",
                            })
                          }
                          placeholder="Select Resource"
                          isClearable
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3 ems-row-gap">
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Event Client</Form.Label>
                        <Select
                          className="ems-react-select"
                          classNamePrefix="ems-react-select"
                          options={customerOptions}
                          value={customerOptions.find((opt) => opt.value === eventData.eventClient)}
                          onChange={(selected) =>
                            setEventData({
                              ...eventData,
                              eventClient: selected?.value || "",
                            })
                          }
                          placeholder="Select Client"
                          isClearable
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          className="ems-form-control"
                          name="eventDescription"
                          value={eventData.eventDescription}
                          onChange={handleChange}
                          placeholder="Enter event description..."
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3 ems-row-gap">
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Entity Type</Form.Label>
                        <Form.Select className="ems-form-control" name="entityType" value={eventData.entityType} onChange={handleChange}>
                          <option value="">Select</option>
                          <option value="Ticket">🎫 Ticket</option>
                          <option value="Project">📁 Project</option>
                        </Form.Select>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="ems-form-group">
                        <Form.Label className="ems-form-label">Entity Id</Form.Label>
                        {eventData.entityType === "Project" ? (
                          <Select
                            className="ems-react-select"
                            classNamePrefix="ems-react-select"
                            options={projectOptions}
                            value={projectOptions.find((opt) => opt.value === eventData.entityId)}
                            onChange={handleEntitySelect}
                            placeholder="Select Project"
                            isClearable
                          />
                        ) : eventData.entityType === "Ticket" ? (
                          <Select
                            className="ems-react-select"
                            classNamePrefix="ems-react-select"
                            options={ticketOptions}
                            value={ticketOptions.find((opt) => opt.value === eventData.entityId)}
                            onChange={handleEntitySelect}
                            placeholder="Select Ticket"
                            isClearable
                          />
                        ) : (
                          <Form.Control
                            className="ems-form-control"
                            name="entityId"
                            value={eventData.entityId}
                            onChange={handleChange}
                            placeholder="Enter Entity Id"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  <div className="text-center mt-4">
                    <Button className="ems-btn-primary" onClick={handleOverviewSave}>
                      ✨ Update Event
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Tab>

          {/* Participants Tab */}
          <Tab eventKey="participants" title="👥 Participants">
            <Card className="ems-glass-card">
              <Card.Body className="ems-card-body">
                <div className="ems-section-header">
                  <h5>➕ Add New Participants</h5>
                </div>

                {participants.map((p, i) => (
                  <Row key={i} className="mb-3 ems-row-gap">
                    <Col md={4}>
                      <Form.Control
                        className="ems-form-control"
                        placeholder="User Id"
                        value={p.userId}
                        onChange={(e) => {
                          const arr = [...participants];
                          arr[i].userId = e.target.value;
                          setParticipants(arr);
                        }}
                      />
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        className="ems-form-control"
                        placeholder="Role"
                        value={p.participantRole}
                        onChange={(e) => {
                          const arr = [...participants];
                          arr[i].participantRole = e.target.value;
                          setParticipants(arr);
                        }}
                      />
                    </Col>
                    <Col md={4}>
                      <Form.Select
                        className="ems-form-control"
                        value={p.status}
                        onChange={(e) => {
                          const arr = [...participants];
                          arr[i].status = e.target.value;
                          setParticipants(arr);
                        }}
                      >
                        <option value="">Select Status</option>
                        <option value="Accepted">✅ Accepted</option>
                        <option value="Pending">⏳ Pending</option>
                        <option value="Declined">❌ Declined</option>
                      </Form.Select>
                    </Col>
                  </Row>
                ))}

                <div className="d-flex gap-2 mb-4">
                  <Button
                    variant="secondary"
                    className="ems-btn-secondary"
                    onClick={() =>
                      setParticipants([
                        ...participants,
                        { userId: "", participantRole: "", status: "" },
                      ])
                    }
                  >
                    <FaPlus /> Add Participant Row
                  </Button>
                  <Button className="ems-btn-primary" onClick={handleAddParticipant}>
                    💾 Save New Participants
                  </Button>
                </div>

                <div className="ems-divider"></div>

                <div className="ems-section-header">
                  <h5>📋 Existing Participants</h5>
                </div>

                <div className="table-responsive">
                  <Table className="ems-table" hover>
                    <thead>
                      <tr>
                        <th>User ID</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {existingParticipants.map((p) => (
                        <tr key={p.participantGuid}>
                          <td><strong>{p.userId}</strong></td>
                          <td>{p.participantRole}</td>
                          <td>
                            <span
                              className={`ems-status-badge ${
                                p.status === "Accepted"
                                  ? "ems-status-accepted"
                                  : p.status === "Pending"
                                  ? "ems-status-pending"
                                  : "ems-status-declined"
                              }`}
                            >
                              {p.status}
                            </span>
                          </td>
                          <td>
                            <div className="ems-action-group">
                              <button className="ems-action-btn ems-action-edit" onClick={() => handleEditParticipant(p)}>
                                <FaEdit /> Edit
                              </button>
                              <button className="ems-action-btn ems-action-delete" onClick={() => handleDeleteParticipant(p.participantGuid)}>
                                <FaTrash /> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Tab>

          {/* Reminders Tab */}
          <Tab eventKey="reminders" title="⏰ Reminders">
            <Card className="ems-glass-card">
              <Card.Body className="ems-card-body">
                <div className="ems-section-header">
                  <h5>⏰ Add New Reminder</h5>
                </div>

                <Row className="ems-row-gap">
                  <Col md={4}>
                    <Form.Control
                      type="number"
                      className="ems-form-control"
                      placeholder="Minutes before event"
                      value={reminderMinutes}
                      onChange={(e) => setReminderMinutes(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Form.Select className="ems-form-control" value={reminderType} onChange={(e) => setReminderType(e.target.value)}>
                      <option value="">Select Type</option>
                      <option value="Email">📧 Email</option>
                      <option value="Notification">🔔 Notification</option>
                      <option value="SMS">📱 SMS</option>
                    </Form.Select>
                  </Col>
                  <Col md={4}>
                    <Form.Select className="ems-form-control" value={isSent} onChange={(e) => setIsSent(e.target.value)}>
                      <option value="">Has been sent?</option>
                      <option value="true">✅ Yes</option>
                      <option value="false">❌ No</option>
                    </Form.Select>
                  </Col>
                </Row>

                <div className="mt-3">
                  <Button className="ems-btn-primary" onClick={handleAddReminder}>
                    💾 Save Reminder
                  </Button>
                </div>

                <div className="ems-divider"></div>

                <div className="ems-section-header">
                  <h5>📋 Existing Reminders</h5>
                </div>

                <div className="table-responsive">
                  <Table className="ems-table" hover>
                    <thead>
                      <tr>
                        <th>Minutes</th>
                        <th>Type</th>
                        <th>Sent</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {existingReminders.map((r) => (
                        <tr key={r.reminderGuid}>
                          <td><strong>{r.reminderMinutes} min</strong></td>
                          <td>
                            {r.reminderType === "Email" && "📧 Email"}
                            {r.reminderType === "Notification" && "🔔 Notification"}
                            {r.reminderType === "SMS" && "📱 SMS"}
                          </td>
                          <td>
                            <span className={`ems-status-badge ${r.isSent ? "ems-status-accepted" : "ems-status-pending"}`}>
                              {r.isSent ? "✓ Sent" : "⏳ Pending"}
                            </span>
                          </td>
                          <td>
                            <div className="ems-action-group">
                              <button className="ems-action-btn ems-action-edit" onClick={() => handleEditReminder(r)}>
                                <FaEdit /> Edit
                              </button>
                              <button className="ems-action-btn ems-action-delete" onClick={() => handleDeleteReminder(r.reminderGuid)}>
                                <FaTrash /> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Tab>

          {/* MoM Tab */}
          <Tab eventKey="mom" title="📝 MoM">
            <Card className="ems-glass-card">
              <Card.Body className="ems-card-body">
                <div className="ems-section-header">
                  <h5>📝 MoM Header</h5>
                </div>

                <Row className="ems-row-gap">
                  <Col md={6}>
                    <Form.Control
                      className="ems-form-control"
                      placeholder="Prepared By (Name/Department)"
                      value={momMeta.preparedBy}
                      onChange={(e) => setMomMeta({ ...momMeta, preparedBy: e.target.value })}
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Control
                      className="ems-form-control"
                      placeholder="Approved By (Name/Department)"
                      value={momMeta.approvedBy}
                      onChange={(e) => setMomMeta({ ...momMeta, approvedBy: e.target.value })}
                    />
                  </Col>
                </Row>

                <div className="mt-3">
                  <Button className="ems-btn-primary" onClick={handleUpdateMoMHeader}>
                    ✨ Update Header
                  </Button>
                </div>

                <div className="ems-divider"></div>

                <div className="ems-section-header">
                  <h5>📋 MoM Details</h5>
                  <Button variant="success" className="ems-btn-success" onClick={() => setShowAddMoMDetailModal(true)}>
                    <FaPlus /> Add MoM Detail
                  </Button>
                </div>

                <div className="table-responsive">
                  <Table className="ems-table" hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Discussion Point</th>
                        <th>Decision Taken</th>
                        <th>Action Item</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {momDetails.map((d, i) => (
                        <tr key={d.moMdetailGuid}>
                          <td><strong>{i + 1}</strong></td>
                          <td>{d.discussionPoint || "-"}</td>
                          <td>{d.decisionTaken || "-"}</td>
                          <td>{d.actionItem || "-"}</td>
                          <td>
                            <div className="ems-action-group">
                              <button className="ems-action-btn ems-action-edit" onClick={() => handleEditMoMDetail(d)}>
                                <FaEdit /> Edit
                              </button>
                              <button className="ems-action-btn ems-action-delete" onClick={() => handleDeleteMoMDetail(d.moMdetailGuid)}>
                                <FaTrash /> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Tab>

          {/* Documents Tab */}
          <Tab eventKey="documents" title="📎 Documents">
            <Card className="ems-glass-card">
              <Card.Body className="ems-card-body">
                {/* Upload Section */}
                <div className="ems-section-header">
                  <h5>📤 Upload New Document</h5>
                </div>

                <Row className="ems-row-gap">
                  <Col md={5}>
                    <div className="ems-form-group">
                      <Form.Label className="ems-form-label">Document Type</Form.Label>
                      <Select
                        className="ems-react-select"
                        classNamePrefix="ems-react-select"
                        options={documentTypeOptions}
                        value={documentTypeOptions.find(opt => opt.value === documentTypeId)}
                        onChange={(selected) => setDocumentTypeId(selected?.value || 1)}
                        placeholder="Select Document Type"
                      />
                    </div>
                  </Col>
                  <Col md={5}>
                    <div className="ems-form-group">
                      <Form.Label className="ems-form-label">Select File (Max 10MB)</Form.Label>
                      <Form.Control
                        id="editDocumentFileInput"
                        type="file"
                        onChange={handleFileSelect}
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                        className="ems-form-control"
                      />
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="ems-form-group">
                      <Form.Label className="ems-form-label">&nbsp;</Form.Label>
                      <Button
                        className="ems-btn-primary w-100"
                        onClick={handleUploadDocument}
                        disabled={!selectedFile || uploadingDoc}
                      >
                        {uploadingDoc ? "Uploading..." : <><FaFileUpload /> Upload</>}
                      </Button>
                    </div>
                  </Col>
                </Row>

                <div className="text-muted small mt-2 mb-4">
                  <FaFileUpload /> Supported: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG, TXT (Max 10MB)
                </div>

                <div className="ems-divider"></div>

                {/* Documents List */}
                <div className="ems-section-header">
                  <h5>📋 Uploaded Documents ({documents.length})</h5>
                </div>

                {documents.length === 0 ? (
                  <div className="text-center text-muted py-4">
                    <FaFile size={40} className="mb-2" />
                    <p>No documents uploaded yet</p>
                    <small>Use the form above to upload documents</small>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table className="ems-table" hover>
                      <thead>
                        <tr>
                          <th>File Name</th>
                          <th>Type</th>
                          <th>Uploaded By</th>
                          <th>Uploaded On</th>
                          <th style={{ width: "150px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {documents.map((doc) => (
                          <tr key={doc.eventDocGuidId}>
                            <td>
                              <div className="d-flex align-items-center">
                                <FaFile style={{ marginRight: "8px", color: "#0d6efd" }} />
                                <span style={{ wordBreak: "break-all" }}>{doc.eventDocName}</span>
                              </div>
                            </td>
                            <td>{documentTypeOptions.find(opt => opt.value === doc.eventDoctypeId)?.label || "Other"}</td>
                            <td>{doc.createdBy || "N/A"}</td>
                            <td>{formatDate(doc.createdOn, doc.createdOnTime)}</td>
                            <td>
                              <div className="ems-action-group">
                                <button
                                  className="ems-action-btn ems-action-edit"
                                  onClick={() => handleDownloadDocument(doc.eventDocGuidId, doc.eventDocName)}
                                  title="Download"
                                >
                                  <FaDownload /> Download
                                </button>
                                <button
                                  className="ems-action-btn ems-action-delete"
                                  onClick={() => handleDeleteDocument(doc.eventDocGuidId)}
                                  title="Delete"
                                >
                                  <FaTrash /> Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Tab>
        </Tabs>

        {/* Edit Participant Modal */}
        <Modal show={showEditParticipantModal} onHide={() => setShowEditParticipantModal(false)} className="ems-modal">
          <Modal.Header closeButton>
            <Modal.Title>✏️ Edit Participant</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">User ID</Form.Label>
              <Form.Control
                className="ems-form-control"
                value={editingParticipant?.userId || ""}
                onChange={(e) => setEditingParticipant({ ...editingParticipant, userId: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Role</Form.Label>
              <Form.Control
                className="ems-form-control"
                value={editingParticipant?.participantRole || ""}
                onChange={(e) => setEditingParticipant({ ...editingParticipant, participantRole: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Status</Form.Label>
              <Form.Select
                className="ems-form-control"
                value={editingParticipant?.status || ""}
                onChange={(e) => setEditingParticipant({ ...editingParticipant, status: e.target.value })}
              >
                <option value="Accepted">✅ Accepted</option>
                <option value="Pending">⏳ Pending</option>
                <option value="Declined">❌ Declined</option>
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditParticipantModal(false)} className="ems-btn-secondary">
              Cancel
            </Button>
            <Button variant="primary" onClick={handleUpdateParticipant} className="ems-btn-primary">
              Update Participant
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Reminder Modal */}
        <Modal show={showEditReminderModal} onHide={() => setShowEditReminderModal(false)} className="ems-modal">
          <Modal.Header closeButton>
            <Modal.Title>⏰ Edit Reminder</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Minutes</Form.Label>
              <Form.Control
                type="number"
                className="ems-form-control"
                value={editingReminder?.reminderMinutes || ""}
                onChange={(e) => setEditingReminder({ ...editingReminder, reminderMinutes: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Type</Form.Label>
              <Form.Select
                className="ems-form-control"
                value={editingReminder?.reminderType || ""}
                onChange={(e) => setEditingReminder({ ...editingReminder, reminderType: e.target.value })}
              >
                <option value="Email">📧 Email</option>
                <option value="Notification">🔔 Notification</option>
                <option value="SMS">📱 SMS</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Sent</Form.Label>
              <Form.Select
                className="ems-form-control"
                value={editingReminder?.isSent ? "true" : "false"}
                onChange={(e) => setEditingReminder({ ...editingReminder, isSent: e.target.value === "true" })}
              >
                <option value="true">✅ Yes</option>
                <option value="false">❌ No</option>
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditReminderModal(false)} className="ems-btn-secondary">
              Cancel
            </Button>
            <Button variant="primary" onClick={handleUpdateReminder} className="ems-btn-primary">
              Update Reminder
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit MoM Detail Modal */}
        <Modal show={showEditMoMDetailModal} onHide={() => setShowEditMoMDetailModal(false)} className="ems-modal">
          <Modal.Header closeButton>
            <Modal.Title>📝 Edit MoM Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Discussion Point</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="ems-form-control"
                value={editingMoMDetail?.discussionPoint || ""}
                onChange={(e) => setEditingMoMDetail({ ...editingMoMDetail, discussionPoint: e.target.value })}
                placeholder="What was discussed?"
              />
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Decision Taken</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="ems-form-control"
                value={editingMoMDetail?.decisionTaken || ""}
                onChange={(e) => setEditingMoMDetail({ ...editingMoMDetail, decisionTaken: e.target.value })}
                placeholder="What was decided?"
              />
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Action Item</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="ems-form-control"
                value={editingMoMDetail?.actionItem || ""}
                onChange={(e) => setEditingMoMDetail({ ...editingMoMDetail, actionItem: e.target.value })}
                placeholder="What needs to be done?"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditMoMDetailModal(false)} className="ems-btn-secondary">
              Cancel
            </Button>
            <Button variant="primary" onClick={handleUpdateMoMDetail} className="ems-btn-primary">
              Update Detail
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add MoM Detail Modal */}
        <Modal show={showAddMoMDetailModal} onHide={() => setShowAddMoMDetailModal(false)} className="ems-modal">
          <Modal.Header closeButton>
            <Modal.Title>➕ Add MoM Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Discussion Point</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="ems-form-control"
                value={newMoMDetail.discussionPoint}
                onChange={(e) => setNewMoMDetail({ ...newMoMDetail, discussionPoint: e.target.value })}
                placeholder="What was discussed?"
              />
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Decision Taken</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="ems-form-control"
                value={newMoMDetail.decisionTaken}
                onChange={(e) => setNewMoMDetail({ ...newMoMDetail, decisionTaken: e.target.value })}
                placeholder="What was decided?"
              />
            </Form.Group>
            <Form.Group className="ems-form-group">
              <Form.Label className="ems-form-label">Action Item</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="ems-form-control"
                value={newMoMDetail.actionItem}
                onChange={(e) => setNewMoMDetail({ ...newMoMDetail, actionItem: e.target.value })}
                placeholder="What needs to be done?"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddMoMDetailModal(false)} className="ems-btn-secondary">
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddMoMDetail} className="ems-btn-primary">
              Add Detail
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default EditEvent;

// import { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import {
//   Container,
//   Form,
//   Button,
//   Row,
//   Col,
//   Card,
//   Tabs,
//   Tab,
//   Table,
//   Modal,
// } from "react-bootstrap";
// import moment from "moment";
// import { toast } from "react-toastify";
// import { getAllEventTypes } from "../Api/Event";
// import Select from "react-select";
// import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";

// import {
//   fetchEventByCode,
//   fetchParticipantsByEvent,
//   fetchRemindersByEvent,
//   fetchMoMByEvent,
// } from "../Api/ViewEvent";

// import {
//   updateEvent,
//   addParticipants,
//   addReminder,
//   addMoM,
//   updateParticipant,
//   deleteParticipant,
//   updateReminder,
//   deleteReminder,
//   updateMoMHeader,
//   updateMoMDetail,
//   deleteMoMDetail,
//   addMoMDetail,
// } from "../Api/Event";

// import { getDepartmentsByOrgId } from "../Api/DepartmentOrgMaster";
// import { getAllCompanyCodes } from "../Api/CompanyLocationMaster";
// import { fetchCostCenters } from "../Api/ResourceMaster";
// import { getResourcesByOrgId } from "../Api/ResourceList";
// import { fetchCustomersByOrgId } from "../Api/InvoiceApi";
// import { fetchProjectsByOrg } from "../Api/ViewProjects";
// import { getTicketsByOrgId } from "../Api/TicketApiOrg";

// import "./EditEvent.css";

// const EditEvent = () => {
//   const { eventCode } = useParams();
//   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
//   const orgId = userDetails?.organisationId;
//   const userId = userDetails?.userId;

//   const [eventData, setEventData] = useState(null);
//   const [eventTypes, setEventTypes] = useState([]);

//   // Dropdown data
//   const [companyOptions, setCompanyOptions] = useState([]);
//   const [departmentOptions, setDepartmentOptions] = useState([]);
//   const [costCenterOptions, setCostCenterOptions] = useState([]);
//   const [resourceOptions, setResourceOptions] = useState([]);
//   const [customerOptions, setCustomerOptions] = useState([]);
//   const [eventTypeOptions, setEventTypeOptions] = useState([]);

//   // Projects and Tickets for Entity
//   const [projects, setProjects] = useState([]);
//   const [tickets, setTickets] = useState([]);

//   const [participants, setParticipants] = useState([]);
//   const [existingParticipants, setExistingParticipants] = useState([]);

//   // Edit Participant State
//   const [showEditParticipantModal, setShowEditParticipantModal] =
//     useState(false);
//   const [editingParticipant, setEditingParticipant] = useState(null);

//   const [reminderMinutes, setReminderMinutes] = useState("");
//   const [reminderType, setReminderType] = useState("");
//   const [isSent, setIsSent] = useState(false);
//   const [existingReminders, setExistingReminders] = useState([]);

//   // Edit Reminder State
//   const [showEditReminderModal, setShowEditReminderModal] = useState(false);
//   const [editingReminder, setEditingReminder] = useState(null);

//   const [existingMoM, setExistingMoM] = useState(null);

//   // MoM STRUCTURE
//   const [momMeta, setMomMeta] = useState({
//     preparedBy: "",
//     approvedBy: "",
//   });

//   const [momDetails, setMomDetails] = useState([]);

//   // Edit MoM Detail State
//   const [showEditMoMDetailModal, setShowEditMoMDetailModal] = useState(false);
//   const [editingMoMDetail, setEditingMoMDetail] = useState(null);

//   // Add MoM Detail State
//   const [showAddMoMDetailModal, setShowAddMoMDetailModal] = useState(false);
//   const [newMoMDetail, setNewMoMDetail] = useState({
//     discussionPoint: "",
//     decisionTaken: "",
//     actionItem: "",
//   });

//   // ================= LOAD DROPDOWNS =================

//   const loadCompanyCodes = async () => {
//     try {
//       const data = await getAllCompanyCodes(orgId);
//       const options = data.map((company) => ({
//         value: company.companyCode,
//         label: `${company.name} (${company.companyCode})`,
//       }));
//       const sortedOptions = options.sort((a, b) =>
//         a.label.localeCompare(b.label),
//       );
//       setCompanyOptions(sortedOptions);
//     } catch (error) {
//       console.error("Error fetching company codes:", error);
//     }
//   };

//   const loadDepartments = async () => {
//     try {
//       const data = await getDepartmentsByOrgId(orgId);
//       const options = data.map((dept) => ({
//         value: dept.guid,
//         label: `${dept.deptDescription} (${dept.deptCode})`,
//       }));
//       const sortedOptions = options.sort((a, b) =>
//         a.label.localeCompare(b.label),
//       );
//       setDepartmentOptions(sortedOptions);
//     } catch (error) {
//       console.error("Error fetching departments:", error);
//     }
//   };

//   const loadCostCenters = async () => {
//     try {
//       const data = await fetchCostCenters();
//       const options = data.map((center) => ({
//         value: center.code,
//         label: `${center.description} (${center.code})`,
//       }));
//       const sortedOptions = options.sort((a, b) =>
//         a.label.localeCompare(b.label),
//       );
//       setCostCenterOptions(sortedOptions);
//     } catch (error) {
//       console.error("Error fetching cost centers:", error);
//     }
//   };

//   const loadResources = async () => {
//     try {
//       const data = await getResourcesByOrgId(orgId);
//       const options = data.map((resource) => ({
//         value: resource.resourceId,
//         label: `${resource.name} (${resource.resourceId})`,
//       }));
//       const sortedOptions = options.sort((a, b) =>
//         a.label.localeCompare(b.label),
//       );
//       setResourceOptions(sortedOptions);
//     } catch (error) {
//       console.error("Error fetching resources:", error);
//     }
//   };

//   const loadCustomers = async () => {
//     try {
//       const data = await fetchCustomersByOrgId(orgId);
//       const options = data.map((customer) => ({
//         value: customer.customerCode,
//         label: `${customer.name} (${customer.customerCode})`,
//       }));
//       const sortedOptions = options.sort((a, b) =>
//         a.label.localeCompare(b.label),
//       );
//       setCustomerOptions(sortedOptions);
//     } catch (error) {
//       console.error("Error fetching customers:", error);
//     }
//   };

//   const loadProjects = async () => {
//     try {
//       const data = await fetchProjectsByOrg(orgId);
//       const sortedProjects = data.sort((a, b) =>
//         a.prTitle.localeCompare(b.prTitle),
//       );
//       setProjects(sortedProjects);
//     } catch (error) {
//       console.error("Error fetching projects:", error);
//     }
//   };

//   const loadTickets = async () => {
//     try {
//       const data = await getTicketsByOrgId(orgId);
//       const sortedTickets = data.sort((a, b) =>
//         a.ticketName.localeCompare(b.ticketName),
//       );
//       setTickets(sortedTickets);
//     } catch (error) {
//       console.error("Error fetching tickets:", error);
//     }
//   };

//   const projectOptions = projects.map((p) => ({
//     value: p.projectId,
//     label: `${p.prTitle} (${p.projectId})`,
//   }));

//   const ticketOptions = tickets.map((t) => ({
//     value: t.ticketId,
//     label: `${t.ticketName} (${t.ticketId})`,
//   }));

//   // ================= LOAD MAIN DATA =================

//   useEffect(() => {
//     loadAll();
//   }, []);

//   useEffect(() => {
//     if (eventData?.entityType === "Project") {
//       loadProjects();
//     } else if (eventData?.entityType === "Ticket") {
//       loadTickets();
//     }
//   }, [eventData?.entityType]);

//   const loadAll = () => {
//     loadEvent();
//     loadParticipants();
//     loadReminders();
//     loadMoM();
//     loadEventTypes();
//     loadCompanyCodes();
//     loadDepartments();
//     loadCostCenters();
//     loadResources();
//     loadCustomers();
//   };

//   const loadEvent = async () => {
//     try {
//       const data = await fetchEventByCode(orgId, eventCode);
//       setEventData({
//         eventName: data.eventName,
//         eventType: data.eventType,
//         eventDate: moment(data.eventDate).format("YYYY-MM-DD"),
//         eventEndDate: data.eventEndDate
//           ? moment(data.eventEndDate).format("YYYY-MM-DD")
//           : "",
//         eventStartTime: data.eventStartTime
//           ? data.eventStartTime.slice(0, 5)
//           : "",
//         eventEndTime: data.eventEndTime ? data.eventEndTime.slice(0, 5) : "",
//         eventLocation: data.eventLocation,
//         organizerName: data.organizerName,
//         budgetAllocation: data.budgetAllocation,
//         department: data.department,
//         eventDescription: data.eventDescription,
//         entityType: data.entityType || "",
//         entityId: data.entityId || "",
//         eventCompanyCode: data.eventCompanyCode || "",
//         eventCostCenter: data.eventCostCenter || "",
//         eventResource: data.eventResource || "",
//         eventClient: data.eventClient || "",
//       });
//     } catch {
//       toast.error("Error loading event");
//     }
//   };

//   const loadParticipants = async () => {
//     try {
//       const data = await fetchParticipantsByEvent(eventCode);
//       setExistingParticipants(data);
//     } catch {
//       toast.error("Error loading participants");
//     }
//   };

//   const loadReminders = async () => {
//     try {
//       const data = await fetchRemindersByEvent(eventCode);
//       setExistingReminders(data);
//     } catch {
//       toast.error("Error loading reminders");
//     }
//   };

//   const loadMoM = async () => {
//     try {
//       const data = await fetchMoMByEvent(eventCode);
//       setExistingMoM(data);
//       setMomMeta({
//         preparedBy: data?.preparedBy || "",
//         approvedBy: data?.approvedBy || "",
//       });
//       setMomDetails(data?.details || []);
//     } catch {
//       toast.error("Error loading MoM");
//     }
//   };

//   const loadEventTypes = async () => {
//     try {
//       const data = await getAllEventTypes();
//       const sortedData = data.sort((a, b) =>
//         a.typeName.localeCompare(b.typeName),
//       );
//       setEventTypes(sortedData);
//       const options = sortedData.map((e) => ({
//         value: e.eventTypeGuid,
//         label: e.typeName,
//       }));
//       setEventTypeOptions(options);
//     } catch {
//       toast.error("Error loading event types");
//     }
//   };

//   // ================= HANDLERS =================

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "entityType") {
//       setEventData({ ...eventData, entityType: value, entityId: "" });
//     } else {
//       setEventData({ ...eventData, [name]: value });
//     }
//   };

//   const handleEntitySelect = (selected) => {
//     setEventData({ ...eventData, entityId: selected?.value || "" });
//   };

//   const handleOverviewSave = async () => {
//     try {
//       const payload = {
//         ...eventData,
//         eventDate: new Date(eventData.eventDate).toISOString(),
//         eventEndDate: eventData.eventEndDate
//           ? new Date(eventData.eventEndDate).toISOString()
//           : null,
//         eventStartTime: eventData.eventStartTime
//           ? `${eventData.eventStartTime}:00`
//           : null,
//         eventEndTime: eventData.eventEndTime
//           ? `${eventData.eventEndTime}:00`
//           : null,
//         eventCompanyCode: eventData.eventCompanyCode || null,
//         eventCostCenter: eventData.eventCostCenter || null,
//         eventResource: eventData.eventResource || null,
//         eventClient: eventData.eventClient || null,
//         entityType: eventData.entityType || null,
//         entityId: eventData.entityId || null,
//         createdBy: String(userId),
//         organisationId: String(orgId),
//       };
//       await updateEvent(eventCode, payload);
//       toast.success("Event Updated Successfully");
//     } catch {
//       toast.error("Failed to update event");
//     }
//   };

//   // ================= PARTICIPANT CRUD =================

//   const handleAddParticipant = async () => {
//     try {
//       const payload = participants.map((p) => ({
//         ...p,
//         createdBy: String(userId),
//         organisationId: String(orgId),
//       }));
//       await addParticipants(eventCode, payload);
//       toast.success("Participants Added");
//       setParticipants([]);
//       loadParticipants();
//     } catch {
//       toast.error("Error adding participants");
//     }
//   };

//   const handleEditParticipant = (participant) => {
//     setEditingParticipant(participant);
//     setShowEditParticipantModal(true);
//   };

//   const handleUpdateParticipant = async () => {
//     try {
//       await updateParticipant(editingParticipant.participantGuid, {
//         userId: editingParticipant.userId,
//         participantRole: editingParticipant.participantRole,
//         status: editingParticipant.status,
//         createdBy: String(userId),
//       });
//       toast.success("Participant updated successfully");
//       setShowEditParticipantModal(false);
//       loadParticipants();
//     } catch {
//       toast.error("Error updating participant");
//     }
//   };

//   const handleDeleteParticipant = async (participantGuid) => {
//     if (window.confirm("Are you sure you want to delete this participant?")) {
//       try {
//         await deleteParticipant(participantGuid, String(userId));
//         toast.success("Participant deleted successfully");
//         loadParticipants();
//       } catch {
//         toast.error("Error deleting participant");
//       }
//     }
//   };

//   // ================= REMINDER CRUD =================

//   const handleAddReminder = async () => {
//     try {
//       const payload = {
//         reminderMinutes: Number(reminderMinutes),
//         reminderType,
//         isSent: isSent === "true",
//         createdBy: String(userId),
//         organisationId: String(orgId),
//       };
//       await addReminder(eventCode, payload);
//       toast.success("Reminder Saved");
//       setReminderMinutes("");
//       setReminderType("");
//       setIsSent(false);
//       loadReminders();
//     } catch {
//       toast.error("Error saving reminder");
//     }
//   };

//   const handleEditReminder = (reminder) => {
//     setEditingReminder(reminder);
//     setShowEditReminderModal(true);
//   };

//   const handleUpdateReminder = async () => {
//     try {
//       await updateReminder(editingReminder.reminderGuid, {
//         reminderMinutes: Number(editingReminder.reminderMinutes),
//         reminderType: editingReminder.reminderType,
//         isSent: editingReminder.isSent,
//         createdBy: String(userId),
//       });
//       toast.success("Reminder updated successfully");
//       setShowEditReminderModal(false);
//       loadReminders();
//     } catch {
//       toast.error("Error updating reminder");
//     }
//   };

//   const handleDeleteReminder = async (reminderGuid) => {
//     if (window.confirm("Are you sure you want to delete this reminder?")) {
//       try {
//         await deleteReminder(reminderGuid, String(userId));
//         toast.success("Reminder deleted successfully");
//         loadReminders();
//       } catch {
//         toast.error("Error deleting reminder");
//       }
//     }
//   };

//   // ================= MOM CRUD =================

//   const handleUpdateMoMHeader = async () => {
//     try {
//       await updateMoMHeader(eventCode, {
//         preparedBy: momMeta.preparedBy,
//         approvedBy: momMeta.approvedBy,
//         changedBy: String(userId),
//       });
//       toast.success("MoM Header updated successfully");
//       loadMoM();
//     } catch {
//       toast.error("Error updating MoM header");
//     }
//   };

//   const handleEditMoMDetail = (detail) => {
//     setEditingMoMDetail(detail);
//     setShowEditMoMDetailModal(true);
//   };

//   const handleUpdateMoMDetail = async () => {
//     try {
//       await updateMoMDetail(editingMoMDetail.moMdetailGuid, {
//         discussionPoint: editingMoMDetail.discussionPoint,
//         decisionTaken: editingMoMDetail.decisionTaken,
//         actionItem: editingMoMDetail.actionItem,
//       });
//       toast.success("MoM detail updated successfully");
//       setShowEditMoMDetailModal(false);
//       loadMoM();
//     } catch {
//       toast.error("Error updating MoM detail");
//     }
//   };

//   const handleDeleteMoMDetail = async (detailGuid) => {
//     if (window.confirm("Are you sure you want to delete this MoM detail?")) {
//       try {
//         await deleteMoMDetail(detailGuid, String(userId));
//         toast.success("MoM detail deleted successfully");
//         loadMoM();
//       } catch {
//         toast.error("Error deleting MoM detail");
//       }
//     }
//   };

//   const handleAddMoMDetail = async () => {
//     try {
//       await addMoMDetail(eventCode, {
//         discussionPoint: newMoMDetail.discussionPoint,
//         decisionTaken: newMoMDetail.decisionTaken,
//         actionItem: newMoMDetail.actionItem,
//         createdBy: String(userId),
//         organisationId: String(orgId),
//       });
//       toast.success("MoM detail added successfully");
//       setShowAddMoMDetailModal(false);
//       setNewMoMDetail({
//         discussionPoint: "",
//         decisionTaken: "",
//         actionItem: "",
//       });
//       loadMoM();
//     } catch {
//       toast.error("Error adding MoM detail");
//     }
//   };
//   if (!eventData) return null;

//   return (
//     <div className="main-content expand">
//       <Container fluid className="ems-edit-container">
//         <div className="ems-title-wrapper">
//           <div className="d-flex align-items-center flex-wrap">
//             <h2 className="ems-page-title">{eventData.eventName}</h2>
//             <div className="ems-event-badge">
//               <span>📅</span>
//               <code>{eventCode}</code>
//             </div>
//           </div>
//         </div>

//         <Tabs defaultActiveKey="overview" className="ems-custom-tabs">
//           {/* Overview Tab */}
//           <Tab eventKey="overview" title="📋 Overview">
//             <Card className="ems-glass-card">
//               <Card.Body className="ems-card-body">
//                 <Form>
//                   <Row className="ems-row-gap">
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Event Name
//                         </Form.Label>
//                         <Form.Control
//                           className="ems-form-control"
//                           name="eventName"
//                           value={eventData.eventName}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </Col>
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Event Type
//                         </Form.Label>
//                         <Select
//                           className="ems-react-select"
//                           classNamePrefix="ems-react-select"
//                           options={eventTypeOptions}
//                           value={eventTypeOptions.find(
//                             (opt) => opt.value === eventData.eventType,
//                           )}
//                           onChange={(selected) =>
//                             setEventData({
//                               ...eventData,
//                               eventType: selected?.value || "",
//                             })
//                           }
//                           placeholder="Select Event Type"
//                         />
//                       </div>
//                     </Col>
//                   </Row>

//                   <Row className="mt-3 ems-row-gap">
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Event Date
//                         </Form.Label>
//                         <Form.Control
//                           type="date"
//                           className="ems-form-control"
//                           name="eventDate"
//                           value={eventData.eventDate}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </Col>
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           End Date
//                         </Form.Label>
//                         <Form.Control
//                           type="date"
//                           className="ems-form-control"
//                           name="eventEndDate"
//                           value={eventData.eventEndDate}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </Col>
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Budget (₹)
//                         </Form.Label>
//                         <Form.Control
//                           type="number"
//                           className="ems-form-control"
//                           name="budgetAllocation"
//                           value={eventData.budgetAllocation}
//                           onChange={handleChange}
//                           placeholder="Enter budget amount"
//                         />
//                       </div>
//                     </Col>
//                   </Row>

//                   <Row className="mt-3 ems-row-gap">
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Start Time
//                         </Form.Label>
//                         <Form.Control
//                           type="time"
//                           className="ems-form-control"
//                           name="eventStartTime"
//                           value={eventData.eventStartTime}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </Col>
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           End Time
//                         </Form.Label>
//                         <Form.Control
//                           type="time"
//                           className="ems-form-control"
//                           name="eventEndTime"
//                           value={eventData.eventEndTime}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </Col>
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Location
//                         </Form.Label>
//                         <Form.Control
//                           className="ems-form-control"
//                           name="eventLocation"
//                           value={eventData.eventLocation}
//                           onChange={handleChange}
//                           placeholder="Enter venue/location"
//                         />
//                       </div>
//                     </Col>
//                   </Row>

//                   <Row className="mt-3 ems-row-gap">
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Organizer
//                         </Form.Label>
//                         <Form.Control
//                           className="ems-form-control"
//                           name="organizerName"
//                           value={eventData.organizerName}
//                           onChange={handleChange}
//                           placeholder="Enter organizer name"
//                         />
//                       </div>
//                     </Col>
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Department
//                         </Form.Label>
//                         <Select
//                           className="ems-react-select"
//                           classNamePrefix="ems-react-select"
//                           options={departmentOptions}
//                           value={departmentOptions.find(
//                             (opt) => opt.value === eventData.department,
//                           )}
//                           onChange={(selected) =>
//                             setEventData({
//                               ...eventData,
//                               department: selected?.value || "",
//                             })
//                           }
//                           placeholder="Select Department"
//                           isClearable
//                         />
//                       </div>
//                     </Col>
//                   </Row>

//                   <Row className="mt-3 ems-row-gap">
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Company Code
//                         </Form.Label>
//                         <Select
//                           className="ems-react-select"
//                           classNamePrefix="ems-react-select"
//                           options={companyOptions}
//                           value={companyOptions.find(
//                             (opt) => opt.value === eventData.eventCompanyCode,
//                           )}
//                           onChange={(selected) =>
//                             setEventData({
//                               ...eventData,
//                               eventCompanyCode: selected?.value || "",
//                             })
//                           }
//                           placeholder="Select Company"
//                           isClearable
//                         />
//                       </div>
//                     </Col>
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Cost Center
//                         </Form.Label>
//                         <Select
//                           className="ems-react-select"
//                           classNamePrefix="ems-react-select"
//                           options={costCenterOptions}
//                           value={costCenterOptions.find(
//                             (opt) => opt.value === eventData.eventCostCenter,
//                           )}
//                           onChange={(selected) =>
//                             setEventData({
//                               ...eventData,
//                               eventCostCenter: selected?.value || "",
//                             })
//                           }
//                           placeholder="Select Cost Center"
//                           isClearable
//                         />
//                       </div>
//                     </Col>
//                     <Col md={4}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Resource
//                         </Form.Label>
//                         <Select
//                           className="ems-react-select"
//                           classNamePrefix="ems-react-select"
//                           options={resourceOptions}
//                           value={resourceOptions.find(
//                             (opt) => opt.value === eventData.eventResource,
//                           )}
//                           onChange={(selected) =>
//                             setEventData({
//                               ...eventData,
//                               eventResource: selected?.value || "",
//                             })
//                           }
//                           placeholder="Select Resource"
//                           isClearable
//                         />
//                       </div>
//                     </Col>
//                   </Row>

//                   <Row className="mt-3 ems-row-gap">
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Event Client
//                         </Form.Label>
//                         <Select
//                           className="ems-react-select"
//                           classNamePrefix="ems-react-select"
//                           options={customerOptions}
//                           value={customerOptions.find(
//                             (opt) => opt.value === eventData.eventClient,
//                           )}
//                           onChange={(selected) =>
//                             setEventData({
//                               ...eventData,
//                               eventClient: selected?.value || "",
//                             })
//                           }
//                           placeholder="Select Client"
//                           isClearable
//                         />
//                       </div>
//                     </Col>
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Description
//                         </Form.Label>
//                         <Form.Control
//                           as="textarea"
//                           rows={3}
//                           className="ems-form-control"
//                           name="eventDescription"
//                           value={eventData.eventDescription}
//                           onChange={handleChange}
//                           placeholder="Enter event description..."
//                         />
//                       </div>
//                     </Col>
//                   </Row>

//                   <Row className="mt-3 ems-row-gap">
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Entity Type
//                         </Form.Label>
//                         <Form.Select
//                           className="ems-form-control"
//                           name="entityType"
//                           value={eventData.entityType}
//                           onChange={handleChange}
//                         >
//                           <option value="">Select</option>
//                           <option value="Ticket">🎫 Ticket</option>
//                           <option value="Project">📁 Project</option>
//                         </Form.Select>
//                       </div>
//                     </Col>
//                     <Col md={6}>
//                       <div className="ems-form-group">
//                         <Form.Label className="ems-form-label">
//                           Entity Id
//                         </Form.Label>
//                         {eventData.entityType === "Project" ? (
//                           <Select
//                             className="ems-react-select"
//                             classNamePrefix="ems-react-select"
//                             options={projectOptions}
//                             value={projectOptions.find(
//                               (opt) => opt.value === eventData.entityId,
//                             )}
//                             onChange={handleEntitySelect}
//                             placeholder="Select Project"
//                             isClearable
//                           />
//                         ) : eventData.entityType === "Ticket" ? (
//                           <Select
//                             className="ems-react-select"
//                             classNamePrefix="ems-react-select"
//                             options={ticketOptions}
//                             value={ticketOptions.find(
//                               (opt) => opt.value === eventData.entityId,
//                             )}
//                             onChange={handleEntitySelect}
//                             placeholder="Select Ticket"
//                             isClearable
//                           />
//                         ) : (
//                           <Form.Control
//                             className="ems-form-control"
//                             name="entityId"
//                             value={eventData.entityId}
//                             onChange={handleChange}
//                             placeholder="Enter Entity Id"
//                           />
//                         )}
//                       </div>
//                     </Col>
//                   </Row>

//                   <div className="text-center mt-4">
//                     <Button
//                       className="ems-btn-primary"
//                       onClick={handleOverviewSave}
//                     >
//                       ✨ Update Event
//                     </Button>
//                   </div>
//                 </Form>
//               </Card.Body>
//             </Card>
//           </Tab>

//           {/* Participants Tab */}
//           <Tab eventKey="participants" title="👥 Participants">
//             <Card className="ems-glass-card">
//               <Card.Body className="ems-card-body">
//                 <div className="ems-section-header">
//                   <h5>➕ Add New Participants</h5>
//                 </div>

//                 {participants.map((p, i) => (
//                   <Row key={i} className="mb-3 ems-row-gap">
//                     <Col md={4}>
//                       <Form.Control
//                         className="ems-form-control"
//                         placeholder="User Id"
//                         value={p.userId}
//                         onChange={(e) => {
//                           const arr = [...participants];
//                           arr[i].userId = e.target.value;
//                           setParticipants(arr);
//                         }}
//                       />
//                     </Col>
//                     <Col md={4}>
//                       <Form.Control
//                         className="ems-form-control"
//                         placeholder="Role"
//                         value={p.participantRole}
//                         onChange={(e) => {
//                           const arr = [...participants];
//                           arr[i].participantRole = e.target.value;
//                           setParticipants(arr);
//                         }}
//                       />
//                     </Col>
//                     <Col md={4}>
//                       <Form.Select
//                         className="ems-form-control"
//                         value={p.status}
//                         onChange={(e) => {
//                           const arr = [...participants];
//                           arr[i].status = e.target.value;
//                           setParticipants(arr);
//                         }}
//                       >
//                         <option value="">Select Status</option>
//                         <option value="Accepted">✅ Accepted</option>
//                         <option value="Pending">⏳ Pending</option>
//                         <option value="Declined">❌ Declined</option>
//                       </Form.Select>
//                     </Col>
//                   </Row>
//                 ))}

//                 <div className="d-flex gap-2 mb-4">
//                   <Button
//                     variant="secondary"
//                     className="ems-btn-secondary"
//                     onClick={() =>
//                       setParticipants([
//                         ...participants,
//                         { userId: "", participantRole: "", status: "" },
//                       ])
//                     }
//                   >
//                     <FaPlus /> Add Participant Row
//                   </Button>
//                   <Button
//                     className="ems-btn-primary"
//                     onClick={handleAddParticipant}
//                   >
//                     💾 Save New Participants
//                   </Button>
//                 </div>

//                 <div className="ems-divider"></div>

//                 <div className="ems-section-header">
//                   <h5>📋 Existing Participants</h5>
//                 </div>

//                 <div className="table-responsive">
//                   <Table className="ems-table" hover>
//                     <thead>
//                       <tr>
//                         <th>User ID</th>
//                         <th>Role</th>
//                         <th>Status</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {existingParticipants.map((p) => (
//                         <tr key={p.participantGuid}>
//                           <td>
//                             <strong>{p.userId}</strong>
//                           </td>
//                           <td>{p.participantRole}</td>
//                           <td>
//                             <span
//                               className={`ems-status-badge ${
//                                 p.status === "Accepted"
//                                   ? "ems-status-accepted"
//                                   : p.status === "Pending"
//                                     ? "ems-status-pending"
//                                     : "ems-status-declined"
//                               }`}
//                             >
//                               {p.status}
//                             </span>
//                           </td>
//                           <td>
//                             <div className="ems-action-group">
//                               <button
//                                 className="ems-action-btn ems-action-edit"
//                                 onClick={() => handleEditParticipant(p)}
//                               >
//                                 <FaEdit /> Edit
//                               </button>
//                               <button
//                                 className="ems-action-btn ems-action-delete"
//                                 onClick={() =>
//                                   handleDeleteParticipant(p.participantGuid)
//                                 }
//                               >
//                                 <FaTrash /> Delete
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Tab>

//           {/* Reminders Tab */}
//           <Tab eventKey="reminders" title="⏰ Reminders">
//             <Card className="ems-glass-card">
//               <Card.Body className="ems-card-body">
//                 <div className="ems-section-header">
//                   <h5>⏰ Add New Reminder</h5>
//                 </div>

//                 <Row className="ems-row-gap">
//                   <Col md={4}>
//                     <Form.Control
//                       type="number"
//                       className="ems-form-control"
//                       placeholder="Minutes before event"
//                       value={reminderMinutes}
//                       onChange={(e) => setReminderMinutes(e.target.value)}
//                     />
//                   </Col>
//                   <Col md={4}>
//                     <Form.Select
//                       className="ems-form-control"
//                       value={reminderType}
//                       onChange={(e) => setReminderType(e.target.value)}
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Email">📧 Email</option>
//                       <option value="Notification">🔔 Notification</option>
//                       <option value="SMS">📱 SMS</option>
//                     </Form.Select>
//                   </Col>
//                   <Col md={4}>
//                     <Form.Select
//                       className="ems-form-control"
//                       value={isSent}
//                       onChange={(e) => setIsSent(e.target.value)}
//                     >
//                       <option value="">Has been sent?</option>
//                       <option value="true">✅ Yes</option>
//                       <option value="false">❌ No</option>
//                     </Form.Select>
//                   </Col>
//                 </Row>

//                 <div className="mt-3">
//                   <Button
//                     className="ems-btn-primary"
//                     onClick={handleAddReminder}
//                   >
//                     💾 Save Reminder
//                   </Button>
//                 </div>

//                 <div className="ems-divider"></div>

//                 <div className="ems-section-header">
//                   <h5>📋 Existing Reminders</h5>
//                 </div>

//                 <div className="table-responsive">
//                   <Table className="ems-table" hover>
//                     <thead>
//                       <tr>
//                         <th>Minutes</th>
//                         <th>Type</th>
//                         <th>Sent</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {existingReminders.map((r) => (
//                         <tr key={r.reminderGuid}>
//                           <td>
//                             <strong>{r.reminderMinutes} min</strong>
//                           </td>
//                           <td>
//                             {r.reminderType === "Email" && "📧 Email"}
//                             {r.reminderType === "Notification" &&
//                               "🔔 Notification"}
//                             {r.reminderType === "SMS" && "📱 SMS"}
//                           </td>
//                           <td>
//                             <span
//                               className={`ems-status-badge ${r.isSent ? "ems-status-accepted" : "ems-status-pending"}`}
//                             >
//                               {r.isSent ? "✓ Sent" : "⏳ Pending"}
//                             </span>
//                           </td>
//                           <td>
//                             <div className="ems-action-group">
//                               <button
//                                 className="ems-action-btn ems-action-edit"
//                                 onClick={() => handleEditReminder(r)}
//                               >
//                                 <FaEdit /> Edit
//                               </button>
//                               <button
//                                 className="ems-action-btn ems-action-delete"
//                                 onClick={() =>
//                                   handleDeleteReminder(r.reminderGuid)
//                                 }
//                               >
//                                 <FaTrash /> Delete
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Tab>

//           {/* MoM Tab */}
//           <Tab eventKey="mom" title="📝 MoM">
//             <Card className="ems-glass-card">
//               <Card.Body className="ems-card-body">
//                 <div className="ems-section-header">
//                   <h5>📝 MoM Header</h5>
//                 </div>

//                 <Row className="ems-row-gap">
//                   <Col md={6}>
//                     <Form.Control
//                       className="ems-form-control"
//                       placeholder="Prepared By (Name/Department)"
//                       value={momMeta.preparedBy}
//                       onChange={(e) =>
//                         setMomMeta({ ...momMeta, preparedBy: e.target.value })
//                       }
//                     />
//                   </Col>
//                   <Col md={6}>
//                     <Form.Control
//                       className="ems-form-control"
//                       placeholder="Approved By (Name/Department)"
//                       value={momMeta.approvedBy}
//                       onChange={(e) =>
//                         setMomMeta({ ...momMeta, approvedBy: e.target.value })
//                       }
//                     />
//                   </Col>
//                 </Row>

//                 <div className="mt-3">
//                   <Button
//                     className="ems-btn-primary"
//                     onClick={handleUpdateMoMHeader}
//                   >
//                     ✨ Update Header
//                   </Button>
//                 </div>

//                 <div className="ems-divider"></div>

//                 <div className="ems-section-header">
//                   <h5>📋 MoM Details</h5>
//                   <Button
//                     variant="success"
//                     className="ems-btn-success"
//                     onClick={() => setShowAddMoMDetailModal(true)}
//                   >
//                     <FaPlus /> Add MoM Detail
//                   </Button>
//                 </div>

//                 <div className="table-responsive">
//                   <Table className="ems-table" hover>
//                     <thead>
//                       <tr>
//                         <th>#</th>
//                         <th>Discussion Point</th>
//                         <th>Decision Taken</th>
//                         <th>Action Item</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {momDetails.map((d, i) => (
//                         <tr key={d.moMdetailGuid}>
//                           <td>
//                             <strong>{i + 1}</strong>
//                           </td>
//                           <td>{d.discussionPoint || "-"}</td>
//                           <td>{d.decisionTaken || "-"}</td>
//                           <td>{d.actionItem || "-"}</td>
//                           <td>
//                             <div className="ems-action-group">
//                               <button
//                                 className="ems-action-btn ems-action-edit"
//                                 onClick={() => handleEditMoMDetail(d)}
//                               >
//                                 <FaEdit /> Edit
//                               </button>
//                               <button
//                                 className="ems-action-btn ems-action-delete"
//                                 onClick={() =>
//                                   handleDeleteMoMDetail(d.moMdetailGuid)
//                                 }
//                               >
//                                 <FaTrash /> Delete
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Tab>
//         </Tabs>

//         {/* Edit Participant Modal */}
//         <Modal
//           show={showEditParticipantModal}
//           onHide={() => setShowEditParticipantModal(false)}
//           className="ems-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>✏️ Edit Participant</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">User ID</Form.Label>
//               <Form.Control
//                 className="ems-form-control"
//                 value={editingParticipant?.userId || ""}
//                 onChange={(e) =>
//                   setEditingParticipant({
//                     ...editingParticipant,
//                     userId: e.target.value,
//                   })
//                 }
//               />
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Role</Form.Label>
//               <Form.Control
//                 className="ems-form-control"
//                 value={editingParticipant?.participantRole || ""}
//                 onChange={(e) =>
//                   setEditingParticipant({
//                     ...editingParticipant,
//                     participantRole: e.target.value,
//                   })
//                 }
//               />
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Status</Form.Label>
//               <Form.Select
//                 className="ems-form-control"
//                 value={editingParticipant?.status || ""}
//                 onChange={(e) =>
//                   setEditingParticipant({
//                     ...editingParticipant,
//                     status: e.target.value,
//                   })
//                 }
//               >
//                 <option value="Accepted">✅ Accepted</option>
//                 <option value="Pending">⏳ Pending</option>
//                 <option value="Declined">❌ Declined</option>
//               </Form.Select>
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowEditParticipantModal(false)}
//               className="ems-btn-secondary"
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleUpdateParticipant}
//               className="ems-btn-primary"
//             >
//               Update Participant
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Edit Reminder Modal */}
//         <Modal
//           show={showEditReminderModal}
//           onHide={() => setShowEditReminderModal(false)}
//           className="ems-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>⏰ Edit Reminder</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Minutes</Form.Label>
//               <Form.Control
//                 type="number"
//                 className="ems-form-control"
//                 value={editingReminder?.reminderMinutes || ""}
//                 onChange={(e) =>
//                   setEditingReminder({
//                     ...editingReminder,
//                     reminderMinutes: e.target.value,
//                   })
//                 }
//               />
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Type</Form.Label>
//               <Form.Select
//                 className="ems-form-control"
//                 value={editingReminder?.reminderType || ""}
//                 onChange={(e) =>
//                   setEditingReminder({
//                     ...editingReminder,
//                     reminderType: e.target.value,
//                   })
//                 }
//               >
//                 <option value="Email">📧 Email</option>
//                 <option value="Notification">🔔 Notification</option>
//                 <option value="SMS">📱 SMS</option>
//               </Form.Select>
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Sent</Form.Label>
//               <Form.Select
//                 className="ems-form-control"
//                 value={editingReminder?.isSent ? "true" : "false"}
//                 onChange={(e) =>
//                   setEditingReminder({
//                     ...editingReminder,
//                     isSent: e.target.value === "true",
//                   })
//                 }
//               >
//                 <option value="true">✅ Yes</option>
//                 <option value="false">❌ No</option>
//               </Form.Select>
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowEditReminderModal(false)}
//               className="ems-btn-secondary"
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleUpdateReminder}
//               className="ems-btn-primary"
//             >
//               Update Reminder
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Edit MoM Detail Modal */}
//         <Modal
//           show={showEditMoMDetailModal}
//           onHide={() => setShowEditMoMDetailModal(false)}
//           className="ems-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>📝 Edit MoM Detail</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">
//                 Discussion Point
//               </Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 className="ems-form-control"
//                 value={editingMoMDetail?.discussionPoint || ""}
//                 onChange={(e) =>
//                   setEditingMoMDetail({
//                     ...editingMoMDetail,
//                     discussionPoint: e.target.value,
//                   })
//                 }
//                 placeholder="What was discussed?"
//               />
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Decision Taken</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 className="ems-form-control"
//                 value={editingMoMDetail?.decisionTaken || ""}
//                 onChange={(e) =>
//                   setEditingMoMDetail({
//                     ...editingMoMDetail,
//                     decisionTaken: e.target.value,
//                   })
//                 }
//                 placeholder="What was decided?"
//               />
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Action Item</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 className="ems-form-control"
//                 value={editingMoMDetail?.actionItem || ""}
//                 onChange={(e) =>
//                   setEditingMoMDetail({
//                     ...editingMoMDetail,
//                     actionItem: e.target.value,
//                   })
//                 }
//                 placeholder="What needs to be done?"
//               />
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowEditMoMDetailModal(false)}
//               className="ems-btn-secondary"
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleUpdateMoMDetail}
//               className="ems-btn-primary"
//             >
//               Update Detail
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Add MoM Detail Modal */}
//         <Modal
//           show={showAddMoMDetailModal}
//           onHide={() => setShowAddMoMDetailModal(false)}
//           className="ems-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>➕ Add MoM Detail</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">
//                 Discussion Point
//               </Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 className="ems-form-control"
//                 value={newMoMDetail.discussionPoint}
//                 onChange={(e) =>
//                   setNewMoMDetail({
//                     ...newMoMDetail,
//                     discussionPoint: e.target.value,
//                   })
//                 }
//                 placeholder="What was discussed?"
//               />
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Decision Taken</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 className="ems-form-control"
//                 value={newMoMDetail.decisionTaken}
//                 onChange={(e) =>
//                   setNewMoMDetail({
//                     ...newMoMDetail,
//                     decisionTaken: e.target.value,
//                   })
//                 }
//                 placeholder="What was decided?"
//               />
//             </Form.Group>
//             <Form.Group className="ems-form-group">
//               <Form.Label className="ems-form-label">Action Item</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 className="ems-form-control"
//                 value={newMoMDetail.actionItem}
//                 onChange={(e) =>
//                   setNewMoMDetail({
//                     ...newMoMDetail,
//                     actionItem: e.target.value,
//                   })
//                 }
//                 placeholder="What needs to be done?"
//               />
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowAddMoMDetailModal(false)}
//               className="ems-btn-secondary"
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleAddMoMDetail}
//               className="ems-btn-primary"
//             >
//               Add Detail
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </Container>
//     </div>
//   );
// };

// export default EditEvent;
